module.exports = __webpack_public_path__ + "img/cns_pca4.1dacb419.png";